import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1020px;
  gap: 0 16px;
`;

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
  border-bottom: 2px solid #9d9d9d;
  position: relative;

  transition: all 0.3s ease-in-out;

  &[data-active="true"] {
    border-bottom: 2px solid #2d2d2d;

    > button {
      color: #2d2d2d;
    }
    > div {
      background-color: #2d2d2d;
    }
  }

  @media (min-width: 640px) {
    padding: 16px;
  }
`;

export const ButtonStep = styled.button`
  all: unset;
  cursor: pointer;
  width: fit-content;
  display: flex;
  padding: 10px 16px;
  transition: all 0.3s ease-in-out;

  color: #9d9d9d;
  text-align: center;
  font-family: Mulish;
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px;

  @media (min-width: 640px) {
    padding: 16px 24px;
    font-size: 20px;
  }
`;
